import { Settings, initApi } from "@gettactic/api";
import {
  DEFAULT_EXCLUDE_SENTRY_STATUS_CODES,
  DEFAULT_TACTIC_API_URL,
  DEFAULT_TACTIC_AUTH_HEADER,
  DEFAULT_TACTIC_DEFAULT_PROTOCOL,
  DEFAULT_TACTIC_DOMAIN_AND_PORT
} from "@gettactic/api";
import * as Sentry from "@sentry/nextjs";
import { replaceLocationHref } from "@gettactic/helpers/src/navigation/replaceLocationHref";


const defaultSettings: Settings = {
  environment:
    process.env.NEXT_PUBLIC_VERCEL_ENV === "production" ? "prod" : "dev",
  slug: null,
  url: typeof window === 'undefined' ? process.env.NEXT_PUBLIC_TACTIC_API_URL_INTERNAL || process.env.NEXT_PUBLIC_TACTIC_API_URL || DEFAULT_TACTIC_API_URL : process.env.NEXT_PUBLIC_TACTIC_API_URL || DEFAULT_TACTIC_API_URL,
  debug: !!process.env.NEXT_PUBLIC_TACTIC_API_DEBUG,
  debugAuth: !!process.env.NEXT_PUBLIC_TACTIC_API_DEBUG_AUTH,
  debugAuthAccess: process.env.NEXT_PUBLIC_TACTIC_API_DEBUG_AUTH,
  debugGet: !!process.env.NEXT_PUBLIC_TACTIC_API_DEBUG_GET,
  protocol:
    process.env.NEXT_PUBLIC_TACTIC_DEFAULT_PROTOCOL ||
    DEFAULT_TACTIC_DEFAULT_PROTOCOL,
  domain:
    process.env.NEXT_PUBLIC_TACTIC_DOMAIN_AND_PORT ||
    DEFAULT_TACTIC_DOMAIN_AND_PORT,
  authHeader: DEFAULT_TACTIC_AUTH_HEADER,
  corsBypass: process.env.NEXT_PUBLIC_UNION_CORS_BYPASS
    ? process.env.NEXT_PUBLIC_UNION_CORS_BYPASS
    : "",
  unionDevAuth: process.env.NEXT_PUBLIC_UNION_DEV_AUTH || "",
  onError: (error: unknown, status?: number) => {
    if (status) {
      if (
        status === 401 &&
        !window.location.pathname.startsWith("/kiosk") &&
        // Guests on a shared request or a public dashboard authenticate with a
        // share token, not a session; a 401 there means an invalid/revoked
        // link, handled in-page.
        !window.location.pathname.startsWith("/public/requests/share") &&
        !window.location.pathname.startsWith("/public/requests/dashboard") &&
        // The MCP consent page sends users to log in with its own URL as the
        // return URL, so the authorization request isn't lost.
        !window.location.pathname.startsWith("/mcp/connect")
      ) {
        replaceLocationHref(
          `${process.env.NEXT_PUBLIC_TACTIC_API_URL}/auth/login?returnUrl=${encodeURIComponent(
            `${window.location.origin}/`
          )}`
        );
      }
      if (
        process.env.NEXT_PUBLIC_VERCEL_ENV !== "production" &&
        status !== 404
      ) {
        console.error("Error from api-client:", error, status);
      }

      // If not authorization or 404, send to Sentry to be logged
      if (
        !process.env.NEXT_PUBLIC_SENTRY_DISABLE &&
        !DEFAULT_EXCLUDE_SENTRY_STATUS_CODES.includes(status)
      ) {
        Sentry.captureException(error, {
          tags: {
            category: "api-client"
          }
        });
      }
    }
  }
};

const { api, settings } = initApi(defaultSettings);
export { api, settings };
